
const faqData = [
    {
        "question": "Para quem é esse produto?",
        "answer": " Este curso é para qualquer pessoa que precisa apresentar ou analisar um conjunto de dados, mas não tem experiência com gráficos e ferramentas de BI. Para iniciantes em análise de dados que desejam aprender a criar apresentações de dados dinâmicas e impactantes."

    },
    {
        "question": "Como funciona o 'Prazo de Garantia'?",
        "answer": "O Prazo de Garantia é o período que você tem para pedir o reembolso integral do valor pago pela sua compra, caso o produto não seja satisfatório."

    },
    {
        "question": "O que é o Certificado de Conclusão digital?",
        "answer": "O cursos online oferecem um certificado digital de conclusão. Alunos podem emitir esse certificado ao final do curso. Esses certificados podem ser compartilhados em redes sociais como o LinkedIn e inseridos em informações curriculares."

    },
    {
        "question": "Como acessar o produto?",
        "answer": `Você receberá o acesso por email. O conteúdo será acessado ou baixado através de um computador, celular, tablet ou outro dispositivo digital. Você também pode acessar o produto comprado nesta página: 
        01 - Faça login na Hotmart clicando em 'Entrar'
        02 - Acesse o menu lateral, clique em 'Minha conta'
        03 - Clique em 'Minhas compras' e lá estarão todos os produtos que você já comprou!`

    },
    {
        "question": "Como faço para comprar?",
        "answer": "Para comprar este curso, clique no botão “Comprar agora”. Lembre-se de que nem todos os cursos estarão sempre disponíveis para compra. É possível que o produtor esteja preparando uma nova turma ainda sem inscrições abertas."

    }

]
export default faqData;
